import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { TeamCalender } from "./entity/team-calender.entity";
import { TeamCalenderAdapter } from "./team-calender.adapter";
import { TeamCalenderController } from "./team-calender.controller";
import { TeamCalenderService } from "./team-calender.service";

@Module({
    imports: [
      TypeOrmModule.forFeature([TeamCalender]),
    ],
    controllers: [TeamCalenderController],
    providers: [TeamCalenderService, TeamCalenderAdapter, ApplicationExceptionHandler],
    exports: [TeamCalenderService]
  })
  export class TeamCalenderModule {}